import { render } from "./SplashScreen.vue?vue&type=template&id=3ee1ed4a&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=3ee1ed4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee1ed4a"]])

export default __exports__